"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.riskFactorColors = exports.riskFactorsSorted = exports.RiskFactor = void 0;
var RiskFactor;
(function (RiskFactor) {
    RiskFactor["Low"] = "risk-low";
    RiskFactor["Medium"] = "risk-medium";
    RiskFactor["High"] = "risk-high";
    RiskFactor["Extreme"] = "risk-extreme";
})(RiskFactor || (exports.RiskFactor = RiskFactor = {}));
exports.riskFactorsSorted = [
    RiskFactor.Low,
    RiskFactor.Medium,
    RiskFactor.High,
    RiskFactor.Extreme,
];
exports.riskFactorColors = {
    [RiskFactor.Low]: "#87c424",
    [RiskFactor.Medium]: "#ffcc1a",
    [RiskFactor.High]: "#ff5b1a",
    [RiskFactor.Extreme]: "#cd1aff",
};
